import axios from "axios";
import { API_BASE_URL } from "configs/AppConfig";
// import { notification } from "antd";

const service = axios.create({
  baseURL: API_BASE_URL,
  timeout: 60000,
});

// Config
const ENTRY_ROUTE = "/login";
const TOKEN_PAYLOAD_KEY = "authorization";
const X_TENANT = "X-Tenant";
const PUBLIC_REQUEST_KEY = "public-request";
const ACCESS_CONTROL_ALLOW_ORIGIN = "access-control-allow-origin";

const endpointEmailTemplate = "services/mspcnm/templates";
const tokenEmailTemplate =
  "eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiI4ZjY1NjY2NC0xMTBlLTNlYzEtYWZkZS05ZWNkMTVmNzc0ZWIiLCJhdXRoIjoiUk9MRV9FSU5WT0lDRV9MU0FUSU5WT0lDRV9BRE1JTiIsInVzZXJJbmZvIjp7InVzZXJDb2RlIjoiZWludm9pY2UubHNhdGludm9pY2UuOGY2NTY2NjQtMTEwZS0zZWMxLWFmZGUtOWVjZDE1Zjc3NGViIiwiZnVsbE5hbWUiOiJOZ3V54buFbiDEkOG7qWMgSGnhur91IiwiZmlyc3RMb2dpblRpbWUiOjE2MzY0NzI4ODIwMDAsImxhc3RMb2dpblRpbWUiOjE2NDMxMTYzNTYxMjQsInVzZXJOYW1lIjoiOGY2NTY2NjQtMTEwZS0zZWMxLWFmZGUtOWVjZDE1Zjc3NGViIiwidGVuYW50Q29kZSI6IkxTQVRJTlZPSUNFIiwiYXBwQ29kZSI6IkVJTlZPSUNFIn0sImNsaWVudEluZm8iOnsiY2xpZW50Q29kZSI6IjhmNjU2NjY0LTExMGUtM2VjMS1hZmRlLTllY2QxNWY3NzRlYiIsImVtYWlsIjoiYWRtaW5AaW52b2ljZS5sc2F0LnZuIiwiZnVsbE5hbWUiOiJOZ3V54buFbiDEkOG7qWMgSGnhur91IiwiY2xpZW50VHlwZSI6MCwiY29udGFjdEVtYWlsIjoiIiwicGhvbmVOdW1iZXIiOiIwOTA5ODQ2NjYwIiwiY3JtUmVmIjoiIn0sImV4cCI6MTk0NTY4MzE1Nn0.NLutlWnIr5nOiumnTC-86eNSb8QDFAOJ7QUaG_nl68sYG3cgwZb4HivsdTqrycHLVn8WO6C01X15ONFWe2yTEA";

// API Request interceptor
service.interceptors.request.use(
  config => {
    return config;
  },
  error => {
    // Do something with request error here
    // notification.error({
    //   message: "Error",
    // });
    Promise.reject(error);
  }
);

// API respone interceptor
service.interceptors.response.use(
  response => {
    return response.data;
  },
  error => {
    return Promise.reject(error);
  }
);

export default service;
